import React from 'react';
import ConnectionsGame from './components/ConnectionsGame';

function App() {
  return (
    <div className="App">
      <main>
        <ConnectionsGame />
      </main>
    </div>
  );
}

export default App;